<template>
  <div id="originDialog">
    <el-dialog title="默认单号来源设置" :visible.sync="originVisible" width="710px" :before-close="closeOriginForm" center
      class="originDialog" :close-on-click-modal="false">
      <div style="margin-bottom:30px;">
        <el-alert
          class="alert systemColor"
          title
          type="info"
          :closable="false"
          show-icon
        >
          <span v-if="form.waybillCode === 'KS' && (form.wpCode === 'SF' || form.wpCode === 'EMS' || form.wpCode === 'YZKDBG')">因快手平台规则，面单账号授权后，自营物流商(如顺丰速运、EMS、邮政快递包裹)均需要再次输入客户编号才可正常打单</span>
          <span v-else>设置默认单号来源后，打单时如果选择该电子面单模板，系统将默认用设置的单号源获取单号</span>
        </el-alert>
      </div>
      <div class="dialog-box-body">
        <el-form :model="form" ref="originForm" label-width="120px" :rules="rules">
          <el-form-item label="默认单号来源" v-if="form.waybillCode === 'YTO' || form.waybillCode === 'YTO_ZD'">
            <el-select v-model="form.waybillKcodeOgigin" placeholder="请选择单号来源" style="width:70%;display:inline-block;">
              <el-option
                v-for="(item, index) in ytoKcodeList"
                :key="form.waybillCode + index"
                :label="item.name ? (item.code + '--' + item.name) : item.code"
                :value="item.code"
              ></el-option>
            </el-select><span class="systemColor" @click="goEleAcount" style="margin-left: 10px;cursor:pointer;">添加电子面单</span>
          </el-form-item>
          <el-form-item label="默认单号来源" v-if="form.waybillCode === 'CN'">
            <el-select v-model="form.waybillKcodeOgigin" placeholder="请选择单号来源" style="width:70%;display:inline-block;">
              <el-option
                v-for="(item, index) in cnOriginList"
                :key="index"
                :label="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :title="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :value="item.id"
              ></el-option>
            </el-select><span class="systemColor" @click="goEleAcount" style="margin-left: 10px;cursor:pointer;">添加电子面单</span>
          </el-form-item>
          <el-form-item label="默认单号来源" v-if="form.waybillCode === 'PDD'">
            <el-select v-model="form.waybillKcodeOgigin" placeholder="请选择单号来源" style="width:70%;display:inline-block;">
              <el-option
                v-for="(item, index) in pddOriginList"
                :key="index"
                :label="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :title="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :value="item.id"
              ></el-option>
            </el-select><span class="systemColor" @click="goEleAcount" style="margin-left: 10px;cursor:pointer;">添加电子面单</span>
          </el-form-item>
          <el-form-item label="默认单号来源" v-if="form.waybillCode === 'LUBAN'">
            <el-select v-model="form.waybillKcodeOgigin" placeholder="请选择单号来源" style="width:70%;display:inline-block;">
              <el-option
                v-for="(item, index) in lubanOriginList"
                :key="index"
                :label="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :title="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :value="item.id"
              ></el-option>
            </el-select><span class="systemColor" @click="goEleAcount" style="margin-left: 10px;cursor:pointer;">添加电子面单</span>
          </el-form-item>
          <el-form-item label="默认单号来源" v-if="form.waybillCode === 'JD'">
            <el-select v-model="form.waybillKcodeOgigin" placeholder="请选择单号来源" style="width:70%;display:inline-block;">
              <el-option
                v-for="(item, index) in jdOriginList"
                :key="index"
                :label="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :title="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :value="item.id"
              ></el-option>
            </el-select><span class="systemColor" @click="goEleAcount" style="margin-left: 10px;cursor:pointer;">添加电子面单</span>
          </el-form-item>
          <el-form-item label="默认单号来源" v-if="form.waybillCode === 'KS'">
            <el-select v-model="form.waybillKcodeOgigin" placeholder="请选择单号来源" style="width:70%;display:inline-block;">
              <el-option
                v-for="(item, index) in ksOriginList"
                :key="index"
                :label="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :title="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :value="item.id"
              ></el-option>
            </el-select><span class="systemColor" @click="goEleAcount" style="margin-left: 10px;cursor:pointer;">添加电子面单</span>
          </el-form-item>
          <el-form-item label="默认单号来源" v-if="form.waybillCode === 'XIAOHS'">
            <el-select v-model="form.waybillKcodeOgigin" placeholder="请选择单号来源" style="width:70%;display:inline-block;">
              <el-option
                v-for="(item, index) in xiaohsOriginList"
                :key="index"
                :label="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :title="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :value="item.id"
              ></el-option>
            </el-select><span class="systemColor" @click="goEleAcount" style="margin-left: 10px;cursor:pointer;">添加电子面单</span>
          </el-form-item>
          <el-form-item label="默认单号来源" v-if="form.waybillCode === 'YZ'">
            <el-select v-model="form.waybillKcodeOgigin" placeholder="请选择单号来源" style="width:70%;display:inline-block;">
              <el-option
                v-for="(item, index) in yzOriginList"
                :key="index"
                :label="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :title="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :value="item.id"
              ></el-option>
            </el-select><span class="systemColor" @click="goEleAcount" style="margin-left: 10px;cursor:pointer;">添加电子面单</span>
          </el-form-item>
          <el-form-item label="默认单号来源" v-if="form.waybillCode === 'WXSPH'||form.waybillCode === 'WXGYS'">
            <el-select v-model="form.waybillKcodeOgigin" placeholder="请选择单号来源" style="width:70%;display:inline-block;">
              <el-option
                v-for="(item, index) in wxOriginList"
                :key="index"
                :label="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :title="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : `(余额: ${item.quantity || 0})`}`"
                :value="item.id"
              ></el-option>
            </el-select><span class="systemColor" @click="goEleAcount" style="margin-left: 10px;cursor:pointer;">添加电子面单</span>
          </el-form-item>
          <el-form-item label="默认单号来源" v-if="form.waybillCode === 'DEWU'">
            <el-select v-model="form.waybillKcodeOgigin" placeholder="请选择单号来源" style="width:70%;display:inline-block;">
              <el-option
                v-for="(item, index) in dewuOriginList"
                :key="index"
                :label="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : ''}`"
                :title="(item.mallName ? (item.mallName + '-') : '') + (item.addressInfo || '') + `${cpCodeList.includes(item.cpCode) ? '' : ''}`"
                :value="item.id"
              ></el-option>
            </el-select><span class="systemColor" @click="goEleAcount" style="margin-left: 10px;cursor:pointer;">添加电子面单</span>
          </el-form-item>
          <el-form-item label="客户编号"
            v-if="form.waybillCode === 'KS' && (form.wpCode === 'SF' || form.wpCode === 'EMS' || form.wpCode === 'YZKDBG')"
            prop="settlementCode">
            <el-input v-model.trim="form.settlementCode" autocomplete="off" placeholder="请输入客户编号" style="width:70%;display:inline-block;"></el-input>
          </el-form-item>
          <el-form-item
            label="独立客户编码"
            v-if="form.waybillCode === 'KS'&& form.wpCode === 'SF'"
            prop="independentSettlementCode">
            <el-input v-model.trim="form.independentSettlementCode" autocomplete="off" placeholder="请输入独立客户编码" style="width:70%;display:inline-block;"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-bottom: 10px;">
        <el-button @click="closeOriginForm">取 消</el-button>
        <el-button type="primary" @click="submitOriginForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPddWaybillSourceApi, getYzdCanPrintKCodeApi } from '@/api/universal';
import { addCustomNewNetBranchApi, getZTOKCodeListApi } from '@/api/waybillPrint/customPrint';
import { editTempMallApi, setDefautPrintAccountApi, updateSettlementCodeApi } from '@/api/baseInfo/printTemplate/eleFaceSheetTpl';
export default {
  name: 'originDialog',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    waybillOrigin: {
      type: Object,
      default: () => {
        return {};
      }
    },
    pageType: {
      type: String,
      default: ''
    },
    outChannel: [String], // 1688分销的
  },
  data() {
    return {
      originVisible: this.isShow,
      form: {
        waybillType: '',
        platformName: '',
        tempName: '',
        mallCode: '',
        waybillKcodeOgigin: '',
        settlementCode: '', // 客户编码
        independentSettlementCode: '' // 独立客户编码
      },
      rules: {
        settlementCode: [{ required: true, message: '请输入客户编号', trigger: 'blur' }],
        independentSettlementCode: [{ required: true, message: '请输入独立客户编码', trigger: 'blur' }]
      },
      storList: [],
      cnOriginList: [],
      pddOriginList: [],
      ytoKcodeList: [],
      lubanOriginList: [],
      jdOriginList: [],
      ksOriginList: [],  // 快手
      xiaohsOriginList: [],
      wxOriginList: [], // 腾讯电子面单
      yzOriginList: [],
      dewuOriginList: [],
      cpCodeList: ['SF', 'EMS', 'YZKDBG'] // 这几个快递公司不显示余额
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  watch: {
    isShow(val) {
      console.log(val)
      this.originVisible = val;
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    closeOriginForm(flag) {
      this.$refs['originForm'].resetFields();
      this.originVisible = false;
      this.$emit('closeOriginForm', flag);
    },
    submitOriginForm() {
      // 表单验证
      this.$refs['originForm'].validate((valid) => {
        if (valid) {
          if(this.form.mallEntityList && this.form.mallEntityList.length) {
            let showTip = false;
            // 如果当前模板以前设置过了默认店铺
            if(this.form.waybillCode === 'CN') {
              // 如果是菜鸟电子面单
              let filterOrigin = this.cnOriginList.filter(item => item.id === this.form.waybillKcodeOgigin)[0];
              if(filterOrigin.platformCode !== this.form.platformTypeOfWayBill) {
                // 如果默认单号来源的平台改了，弹窗提示
                showTip = true;
              }
            }
            if(this.form.waybillCode === 'LUBAN') {
              // 如果是抖音电子面单
              let filterOrigin = this.lubanOriginList.filter(item => item.id === this.form.waybillKcodeOgigin)[0];
              if(filterOrigin.platformCode !== this.form.platformTypeOfWayBill) {
                // 如果默认单号来源的平台改了，弹窗提示
                showTip = true;
              }
            }
            if(this.form.waybillCode === 'DEWU') {
              // 如果是得物电子面单
              let filterOrigin = this.dewuOriginList.filter(item => item.id === this.form.waybillKcodeOgigin)[0];
              if(filterOrigin.platformCode !== this.form.platformTypeOfWayBill) {
                // 如果默认单号来源的平台改了，弹窗提示
                showTip = true;
              }
            }
            if(showTip) {
              this.$confirm('当前模板的默认店铺不能使用该单号来源，确定后，默认店铺将清空。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.confirm('clear');
              })
            } else {
              // 如果默认单号来源的平台没有变化，则直接更新
              this.confirm();
            }
          } else {
            this.confirm();
          }
        }
      });
    },
    confirm(str) {
      // 保存接口
      let params = {
        isShare: '',
        groupId: this.form.groupId,
        ...this.form
      };
      if (params.createTime) {
        delete params.createTime;
      }
      if (params.modifyTime) {
        delete params.modifyTime;
      }
      if (!this.form.waybillKcodeOgigin) {
        this.$message.error('请选择默认单号来源');
        return false;
      }
      switch (this.form.waybillCode) {
        case 'YTO':
        case 'YTO_ZD':
          params.printAccount = this.form.waybillKcodeOgigin;
          if (this.form.wpCode === 'YTO' || this.form.wpCode === 'YTO_ZD') {
            params.groupId = this.userMess.groupId;
          }
          break;
        case 'CN':
          params.wayBillbindId = this.form.waybillKcodeOgigin;
          let cnList = this.cnOriginList.filter(item => { return item.id === this.form.waybillKcodeOgigin; });
          params.printAccount = cnList.length ? cnList[0].mallId : '';
          break;
        case 'PDD':
          params.wayBillbindId = this.form.waybillKcodeOgigin.split('_')[0];
          let pddList = this.pddOriginList.filter(item => { return item.id === this.form.waybillKcodeOgigin; });
          params.printAccount = pddList.length ? pddList[0].mallCode : '';
          break;
        case 'LUBAN':
          params.wayBillbindId = this.form.waybillKcodeOgigin;
          let lubanList = this.lubanOriginList.filter(item => { return item.id === this.form.waybillKcodeOgigin; });
          params.printAccount = lubanList.length ? lubanList[0].mallId : '';
          break;
        case 'JD':
          params.wayBillbindId = this.form.waybillKcodeOgigin;
          let jingdongList = this.jdOriginList.filter(item => { return item.id === this.form.waybillKcodeOgigin; });
          params.printAccount = jingdongList.length ? jingdongList[0].mallId : '';
          break;
        case 'KS':
          params.wayBillbindId = this.form.waybillKcodeOgigin;
          let ksList = this.ksOriginList.filter(item => { return item.id === this.form.waybillKcodeOgigin; });
          params.printAccount = ksList.length ? ksList[0].mallId : '';
          break;
        case 'XIAOHS':
          params.wayBillbindId = this.form.waybillKcodeOgigin;
          let xiaohsList = this.xiaohsOriginList.filter(item => { return item.id === this.form.waybillKcodeOgigin; });
          params.printAccount = xiaohsList.length ? xiaohsList[0].mallId : '';
          break;
        case 'YZ':
          params.wayBillbindId = this.form.waybillKcodeOgigin;
          let yzList = this.yzOriginList.filter(item => { return item.id === this.form.waybillKcodeOgigin; });
          params.printAccount = yzList.length ? yzList[0].mallId : '';
          break;
        case 'WXSPH':
        case 'WXGYS':
          params.wayBillbindId = this.form.waybillKcodeOgigin;
          let wxList = this.wxOriginList.filter(item => item.id === this.form.waybillKcodeOgigin);
          params.printAccount = wxList.length ? wxList[0].mallId : '';
          break;
        case 'DEWU':
          params.wayBillbindId = this.form.waybillKcodeOgigin;
          let dewuList = this.dewuOriginList.filter(item => { return item.id === this.form.waybillKcodeOgigin; });
          params.printAccount = dewuList.length ? dewuList[0].mallId : '';
          break;
        default:
          break;
      }
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      let apiArr = [setDefautPrintAccountApi(params)];
      if(str === 'clear') {
        // 需要清除默认店铺的设置
        let mallEntityList = [];
        this.form.mallEntityList.forEach(item => {
          mallEntityList.push({
            ...item,
            isCheck: 'N'
          })
        })
        let params1= {
          tempId: this.form.tempId,
          mallEntityList
        }
        apiArr.push(editTempMallApi(params1))
      }

      Promise.all(apiArr).then(res => {
        let res0 = res[0];
        if (res0.message === 'ok') {
          if (this.form.waybillCode == 'KS' && (this.form.wpCode === 'SF' || this.form.wpCode === 'EMS' || this.form.wpCode === 'YZKDBG')) {
            let upParams = {
              id: params.wayBillbindId || '',
              settlementCode: this.form.settlementCode || '',
              independentSettlementCode: this.form.independentSettlementCode || ''
            };
            updateSettlementCodeApi(upParams).then(res1 => {
              if (res1.message === 'ok') {
                this.closeOriginForm('refresh');
              } else {
                this.$message.error(res1.message || '修改客户编号信息失败');
              }
            }).catch((err) => {
              loadingMask.close();
              this.$message.error(err.message || '修改客户编号信息失败');
            });
          } else {
            this.closeOriginForm('refresh');
          }
        } else {
          this.$message.error(res0.error || res0.message || '设置默认面单来源失败');
        }
        loadingMask.close();
      }).catch((err) => {
        loadingMask.close();
        this.$message.error(err.message || '设置默认面单来源失败');
      });
    },
    // 获取菜鸟订单来源
    getCnOriginList(params) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      addCustomNewNetBranchApi(params).then(res => {
        if (res.message === 'ok') {
          let arrForOriginal = res.data || [];
          if (this.pageType == 'TAOBAO') {
            arrForOriginal = arrForOriginal.filter(p => { return p.platformCode == 'TAOBAO'; });
          }
          if(this.outChannel && this.outChannel === 'TAOBAO') {
            // 1688分销淘宝的模板
            arrForOriginal = arrForOriginal.filter(p => { return p.platformCode == 'TAOBAO'; });
          }
          this.cnOriginList =  [];
          arrForOriginal.forEach(o => {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.cnOriginList.push(o);
          });
          let list = this.cnOriginList.filter(item => { return item.id === this.form.wayBillbindId; });
          if (list.length) {
            this.form.waybillKcodeOgigin = list[0].id;
          }
        } else {
          this.cnOriginList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.cnOriginList = [];
        loadingMask.close();
      });
    },
    // 获取拼多多订单来源
    getPddOriginList(params) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      getPddWaybillSourceApi(params).then(res => {
        if (res.message === 'ok') {
          let arrForOriginal = res.data || [];
          this.pddOriginList = [];
          arrForOriginal.forEach(o => {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.pddOriginList.push(o);
          });
          let list = this.pddOriginList.filter(item => { return item.id === (this.form.wayBillbindId + '_' + this.form.mallId); });
          if (list.length) {
            this.form.waybillKcodeOgigin = list[0].id;
          }
        } else {
          this.pddOriginList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.pddOriginList = [];
        loadingMask.close();
      });
    },
    // 其他快递公司k码列表
    getOtherKcodeList(params) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      getZTOKCodeListApi(params).then(res => {
        if (res.success) {
          let list = res.data || [];
          list.forEach((item) => {
            item.code = item.account;
            item.name = '';
            item.printKey = item.secretKey;
          });
          this.ytoKcodeList = [...list];
        } else {
          this.ytoKcodeList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.ytoKcodeList = [];
        loadingMask.close();
      });
    },
    // 获取圆通客户编码列表
    getCustomerCodeList() {
      let params = {
        userId: this.userMess.loginId,
        groupId: this.userMess.groupId,
        shareFlag: false
      };
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      getYzdCanPrintKCodeApi(params).then(res => {
        if (res.status === 0) {
          this.ytoKcodeList = res.data || [];
        } else {
          this.ytoKcodeList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.ytoKcodeList = [];
        loadingMask.close();
      });
    },
    // 得物店铺来源列表
    getDewuOriginList(params) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      addCustomNewNetBranchApi(params).then(res => {
        if (res.message === 'ok') {
          let arrForOriginal = res.data || [];
          this.dewuOriginList =  [];
          arrForOriginal.forEach(o => {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.dewuOriginList.push(o);
          });
          let list = this.dewuOriginList.filter(item => { return item.id === this.form.wayBillbindId; });
          if (list.length) {
            this.form.waybillKcodeOgigin = list[0].id;
          }
        } else {
          this.dewuOriginList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.dewuOriginList = [];
        loadingMask.close();
      });
    },
    // 抖音店铺来源列表
    getLubanOriginList(params) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      addCustomNewNetBranchApi(params).then(res => {
        if (res.message === 'ok') {
          let arrForOriginal = res.data || [];
          this.lubanOriginList =  [];
          arrForOriginal.forEach(o => {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.lubanOriginList.push(o);
          });
          let list = this.lubanOriginList.filter(item => { return item.id === this.form.wayBillbindId; });
          if (list.length) {
            this.form.waybillKcodeOgigin = list[0].id;
          }
        } else {
          this.lubanOriginList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.lubanOriginList = [];
        loadingMask.close();
      });
    },
    // 京东店铺来源列表
    getJDOriginList(params) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      addCustomNewNetBranchApi(params).then(res => {
        if (res.message === 'ok') {
          let arrForOriginal = res.data || [];
          this.jdOriginList =  [];
          arrForOriginal.forEach(o => {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.jdOriginList.push(o);
          });
          let list = this.jdOriginList.filter(item => { return item.id === this.form.wayBillbindId; });
          if (list.length) {
            this.form.waybillKcodeOgigin = list[0].id;
          }
        } else {
          this.jdOriginList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.jdOriginList = [];
        loadingMask.close();
      });
    },
    // 快手店铺来源列表
    async getKsOriginList(params) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      await addCustomNewNetBranchApi(params).then(res => {
        if (res.message === 'ok') {
          let arrForOriginal = res.data || [];
          this.ksOriginList =  [];
          arrForOriginal.forEach(o => {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.ksOriginList.push(o);
          });
          let list = this.ksOriginList.filter(item => { return item.id === this.form.wayBillbindId; });
          if (list.length) {
            this.$nextTick(() => {
              this.form.waybillKcodeOgigin = list[0].id;
              this.form.settlementCode = list[0].settlementCode || '';
              this.form.independentSettlementCode = list[0].independentSettlementCode || '';
            });
          }
        } else {
          this.ksOriginList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.ksOriginList = [];
        loadingMask.close();
      });
    },
    async getXiaohsOriginList(params) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      await addCustomNewNetBranchApi(params).then(res => {
        if (res.message === 'ok') {
          let arrForOriginal = res.data || [];
          this.xiaohsOriginList =  [];
          arrForOriginal.forEach(o => {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.town || '') + (o.detail || '');
            this.xiaohsOriginList.push(o);
          });
          let list = this.xiaohsOriginList.filter(item => { return item.id === this.form.wayBillbindId; });
          if (list.length) {
            this.$nextTick(() => {
              this.form.waybillKcodeOgigin = list[0].id;
              this.form.settlementCode = list[0].settlementCode || '';
              this.form.independentSettlementCode = list[0].independentSettlementCode || '';
            });
          }
        } else {
          this.xiaohsOriginList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.xiaohsOriginList = [];
        loadingMask.close();
      });
    },
    async getYzOriginList(params) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      await addCustomNewNetBranchApi(params).then(res => {
        if (res.message === 'ok') {
          let arrForOriginal = res.data || [];
          this.yzOriginList =  [];
          arrForOriginal.forEach(o => {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.town || '') + (o.detail || '');
            this.yzOriginList.push(o);
          });
          let list = this.yzOriginList.filter(item => { return item.id === this.form.wayBillbindId; });
          if (list.length) {
            this.$nextTick(() => {
              this.form.waybillKcodeOgigin = list[0].id;
              this.form.settlementCode = list[0].settlementCode || '';
              this.form.independentSettlementCode = list[0].independentSettlementCode || '';
            });
          }
        } else {
          this.yzOriginList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.yzOriginList = [];
        loadingMask.close();
      });
    },
    // 微信小店店铺来源列表
    async getWxOriginList(params) {
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      await addCustomNewNetBranchApi(params).then(res => {
        if (res.message === 'ok') {
          let arrForOriginal = res.data || [];
          this.wxOriginList =  [];
          arrForOriginal.forEach(o => {
            o.addressInfo = (o.province || '') + (o.city || '') + (o.district || '') + (o.detail || '');
            this.wxOriginList.push(o);
          });
          let list = this.wxOriginList.filter(item => { return item.id === this.form.wayBillbindId; });
          if (list.length) {
            this.$nextTick(() => {
              this.form.waybillKcodeOgigin = list[0].id;
              this.form.settlementCode = list[0].settlementCode || '';
              this.form.independentSettlementCode = list[0].independentSettlementCode || '';
            });
          }
        } else {
          this.wxOriginList = [];
        }
        loadingMask.close();
      }).catch(() => {
        this.wxOriginList = [];
        loadingMask.close();
      });
    },
    // 电子面单账号
    goEleAcount() {
      this.$router.push({ name: 'ElectronicBillManagement' });
    },
    init() {
      this.form = {...{settlementCode: '',independentSettlementCode: ''}, ...this.waybillOrigin};
      this.$set(this.form, 'waybillKcodeOgigin', this.form.printAccount || '');
      switch (this.form.waybillCode) {
        case 'YTO':
        case 'YTO_ZD':
          // k 列表
          if (this.form.wpCode === 'YTO') {
            // 圆通k 列表
            this.getCustomerCodeList();
          } else {
            // 其它快递公司k列表
            let params = {
              cpCode: this.form.wpCode,
              loginId: this.userMess.loginId
            };
            this.getOtherKcodeList(params);
          }
          break;
        case 'CN':
          // 菜鸟来源列表
          let params = {
            cpCode: this.form.wpCode,
            loginId: this.userMess.loginId,
            platformCode: this.form.waybillCode,
            type: 'all'
          };
          this.getCnOriginList(params);
          break;
        case 'PDD':
          // 拼多多来源列表
          let pddParams = {wpCode: this.form.wpCode};
          this.getPddOriginList(pddParams);
          break;
        case 'LUBAN':
          // 抖音来源列表
          let lubanParams = {
            cpCode: this.form.wpCode,
            loginId: this.userMess.loginId,
            platformCode: (this.pageType=== 'CUSTOM' ? 'LUBAN' : this.pageType) || this.form.waybillCode
          };
          this.getLubanOriginList(lubanParams);
          break;
        case 'JD':
          // 抖音来源列表
          let jingdongParams = {
            cpCode: this.form.wpCode,
            loginId: this.userMess.loginId,
            platformCode: this.form.waybillCode
          };
          this.getJDOriginList(jingdongParams);
          break;
        case 'KS':
          // 快手电子面单来源列表
          let ksParams = {
            cpCode: this.form.wpCode,
            loginId: this.userMess.loginId,
            platformCode: this.form.waybillCode
          };
          this.getKsOriginList(ksParams);
          break;
        case 'XIAOHS':
          // 小红书电子面单来源列表
          let xiaohsParams = {
            cpCode: this.form.wpCode,
            loginId: this.userMess.loginId,
            platformCode: this.form.waybillCode,
            billVersion: 2
          };
          this.getXiaohsOriginList(xiaohsParams);
          break;
        case 'YZ':
          // 有赞电子面单来源列表
          let yzParams = {
            cpCode: this.form.wpCode,
            loginId: this.userMess.loginId,
            platformCode: this.form.waybillCode
          };
          this.getYzOriginList(yzParams);
          break;
        case 'WXSPH':
        case 'WXGYS':
          // 腾讯电子面单来源列表
          let wxParams = {
            cpCode: this.form.wpCode, // 快递公司
            loginId: this.userMess.loginId,
            platformCode: this.form.waybillCode,
          }
          this.getWxOriginList(wxParams);
          break;
        case 'DEWU':
          // 得物来源列表
          let dewuParams = {
            cpCode: this.form.wpCode,
            loginId: this.userMess.loginId,
            platformCode: this.form.waybillCode
          };
          this.getDewuOriginList(dewuParams);
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scope>
.dialog-box-body {
  width: 480px;
  margin: 0 auto;
}
</style>
